/**
 * 服务类 UTFGridLayer 矢量瓦片
 */
import L from 'leaflet';
// 引入 leaflet.markercluster
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster";
import context from '../context';
export default L.Layer.extend({
    options: {
        layerId: null,
        geoJson: null
    },
    // 定义初始化方法
    initialize: function (options) {
        console.log(context.map);
        // 在初始化方法中可以接收一些参数，并进行一些初始化操作
        L.setOptions(this, options);
    },

    // 在 addLayer 方法中定义如何向地图添加图层
    onAdd: function (map) {
        console.log(map);
        // 在这里可以添加图层到地图上
        // 比如，创建 DOM 元素并将其添加到地图容器中 this.options.url
        this._mapLayer = new L.UtfGrid('http://{s}.tiles.mapbox.com/v3/mapbox.geography-class/{z}/{x}/{y}.grid.json?callback={cb}', {
            resolution: 2
        });
        context.map.addLayer(this._mapLayer);

        this._mapLayer.on("mouseover", function (e) {

        });
        this._mapLayer.on("click", function (e) {

        });
    },

    // 在 removeLayer 方法中定义如何从地图移除图层
    onRemove: function (map) {
        console.log(map);
        // 在这里可以移除图层，清理资源等操作
    }
});